import type { ReactNode } from 'react';
import Dialog from './ui/Dialog';

interface ModalProps {
  /** Whether the modal is currently open. */
  open: boolean;
  title?: string;
  onClose: () => void;
  /** Content (form / detail body) to render inside the modal. */
  children: ReactNode;
  /** Optional icon node shown next to the title. */
  icon?: ReactNode;
  /** Max-width CSS class, e.g. "max-w-md" (default). */
  sizeClass?: string;
}

/**
 * Generic overlay for forms and detail panels (kept for existing callers).
 *
 * Since M3 (T-27) this is a thin wrapper over `ui/Dialog`: focus trap, Escape
 * (topmost only), focus returns to the opener, scroll lock, `inert` shell,
 * enter and exit motion, and a bottom sheet below md. New code uses
 * `ui/Dialog` directly.
 */
export default function Modal({ open, title, onClose, children, icon, sizeClass = 'max-w-md' }: ModalProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={title}
      icon={icon}
      className={sizeClass}
      hideCloseButton={!title}
    >
      {children}
    </Dialog>
  );
}
